<!--
  文件名：Home
  描述：首页
  修改人：〈高琛
  修改时间：2020-01-19
  修改内容：新增页面
  -->
<template>
<div class="home">
    <Banner>
        <img slot="banner-img" src="../assets/img/banner.jpg" alt="" />
		<div slot="banner-bigSlogan">促进决策科学化 为社会创造新价值</div>
		<div slot="banner-slogan" :style="{'visibility':bannerText?'':'hidden'}">{{ bannerText }}</div>
        <button slot="banner-button" @click="goGw()"></button>
    </Banner>
    <div class="container section">
        <div class="row row-1">
            <div class="item item-left pull-left">
                <div class="swiper-box">
                    <Swiper ref="mySwiper" :options="swiperOptions">
                        <SwiperSlide class="swiperItem" v-for="(i, index) in carouselStudyList" :key="index">
                            <img :src="i.coverPic" alt="" :data-link="i.id" />
                            <!-- <button class="click" >详细内容</button> -->
                            <p class="title">{{ i.title }}</p>
                        </SwiperSlide>

                    </Swiper>
                    <div class="swiper-btn swiper-button-prev"></div>
                    <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
                    <div class="swiper-btn swiper-button-next"></div>
                    <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
                </div>
            </div>
            <div class="item study pull-right">
                <div class="title">
                    <div class=" viewMore name ">
                        <router-link to="/researchlist">研究成果<span>>>></span></router-link>
                    </div>
                    <!-- <button class="viewMore">

            </button> -->
                </div>
                <div class="info">
                    <li class="studyItem" v-for="i in hotStudyList">
                        <!-- <div class="date">{{ i.date }}</div> -->
                        <div class="detail" @click="goUrl('Detail', i)">
                            {{ i.title }}
                        </div>
                        <div class="moreDetail">
                            {{ i.information }}
                        </div>
                    </li>
                </div>
            </div>
        </div>
        <div class="row row-2">
            <div class="viewMore name">
                <router-link to="/newslist">新闻活动<span>>>></span></router-link>
            </div>
            <div v-if="hotNews[0]" class="item pull-left">
                <div class="title" @click="goUrl('Detail', hotNews[0])">
                    {{ hotNews[0].title }}
                </div>
                <div class="date">{{ hotNews[0].date }}</div>
                <div class="info">{{ hotNews[0].information }}</div>
                <img :src="hotNews[0].coverPic" :alt="hotNews[0].title" />
            </div>
            <div v-if="hotNews[0]" class="item pull-right">
                <div class="title" @click="goUrl('Detail', hotNews[1])">
                    {{ hotNews[1].title }}
                </div>
                <div class="date">{{ hotNews[1].date }}</div>
                <div class="info">{{ hotNews[1].information }}</div>
                <img :src="hotNews[1].coverPic" :alt="hotNews[1].title" />
            </div>
        </div>
        <div class="row row-3">
            <!-- <div class="name">大事件</div> -->
            <button class="viewMore name">
                <router-link to="/bignewslist">大事件<span>>>></span></router-link>
            </button>
            <div class="item item-1">
                <div class="img pull-left">
                    <img v-if="bigNews[0]" :src="bigNews[0].coverPic" :alt="bigNews[0].title" />
                    <div v-if="bigNews[0] && bigNews[0].videoLink" @click="play(bigNews[0].videoLink)" class="videoPlayer"></div>
                </div>
                <div class="info pull-right">
                    <div v-if="bigNews[0]" class="title" @click="goUrl('Detail', bigNews[0],true)">
                        {{ bigNews[0].title }}
                    </div>
                    <div v-if="bigNews[0]" class="detail">
                        {{ bigNews[0].information }}
                    </div>
                </div>
            </div>
            <div class="item item-2">
                <div class="img pull-right">
                    <img v-if="bigNews[1]" :src="bigNews[1].coverPic" :alt="bigNews[1].title" />
                    <div v-if="bigNews[1] && bigNews[1].videoLink" @click="play(bigNews[1].videoLink)" class="videoPlayer"></div>
                </div>
                <div class="info pull-left">
                    <div v-if="bigNews[1]" class="title" @click="goUrl('Detail', bigNews[1],true)">
                        {{ bigNews[1].title }}
                    </div>
                    <div v-if="bigNews[1]" class="detail">
                        {{ bigNews[1].information }}
                    </div>
                </div>
            </div>
        </div>
		<div class="row row-6">
		    <div class="bigTitle">我们一直在服务>>></div>
		    <div class="content">
		        <servecarousel></servecarousel>
		    </div>
		</div>
        <div class="row row-5">
            <div class="bigTitle">数据服务</div>
            <div class="content">
                <div class="item" v-for="i in iconList" @click="goUrl(i.link)">
                    <div class="icon">
                        <img :src="i.icon" alt="" />
                    </div>
                    <div class="title">{{ i.title }}</div>
                </div>
            </div>
        </div>

    </div>
    <!-- 视频播放 -->
    <VideoPlayer ref="player" />
	<Announcement />
</div>
</template>

<script>
// @ is an alias to /src

import IconList from "../data/iconList";
import Banner from "@/components/Banner.vue";
import Announcement from "@/components/Announcement.vue";
import servecarousel from "@/components/serveCarousel";
import {
    _news_page_v2,
    _report_page_v2,
    getBanner
} from "@/assets/js/api";

import {
    Swiper,
    SwiperSlide
} from "vue-awesome-swiper";
import VideoPlayer from "@/components/VideoPlayer";
import "swiper/css/swiper.css";
import util from '@/utils/utils2.js'

export default {
    name: "Home",
    components: {
        Swiper,
        SwiperSlide,
        Banner,
        VideoPlayer,
		Announcement,
		servecarousel
    },
    computed: {
        player() {
            return this.$refs.player;
        },
    },
    data() {
        let _self = this;
        return {
            //请求回来的数据
            newsList: [],
            carouselStudyList: [],
            hotStudyList: [],
            iconList: [],
            //处理后的数据
            hotNews: [],
            bigNews: [],

            swiperOptions: {
                // 自动播放
                autoplay: true,
                // 环路播放
                loop: true,
                preventLinksPropagation: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                onSlideChangeEnd: function (swiper) {
                    swiper.update();
                    swiper.startAutoplay();
                    swiper.reLoop();
                },
                on: {
                    click: function (e) {
                        const ID = e.target.getAttribute("data-link");
                        if (ID) {
                            _self.goUrl("Detail", {
                                id: ID,
                                origin: null
                            });
                        }
                    },
                },
            },
            formItem: {
                current: 1,
                size: 999,
				status:1
            },
            bannerText:''
        };
    },
    created() {
        this.getList();
        this.getBannerText()
    },
    beforeMount() {
        this.iconList = IconList.iconList;
    },
    mounted() {
        this.scrollTo(0);
    },
    methods: {
        //获取新闻/报告列表
        async getList() {
            let newsData = await _news_page_v2(this.formItem);
            let reportData = await _report_page_v2(this.formItem);
            newsData.data.records.forEach((news) => {
                this.newsList.push(news);
                //热点
                if (news.top && news.type == "1") {
                    this.hotNews.push(news);
                }
                //大事件
                if (news.top && news.type == "2") {
                    this.bigNews.push(news);
                }
            });

            reportData.data.records.forEach((study, index) => {
                //轮播
                if (study.top == 1) {
                    this.carouselStudyList.push(study);
                }
                //侧边列表
                if (study.hot == 1) {
                    this.hotStudyList.push(study);
                }
            });
            // this.line(this.hotNews);
            // this.line(this.bigNews);
            // this.line(this.carouselStudyList);
            // this.line(this.hotStudyList);
			//限制展示6张抡博
			this.carouselStudyList = this.carouselStudyList.splice(0,6)
			//处理轮播图滑动时第一张为最后一张的bug
			this.carouselStudyList.push(this.carouselStudyList[0])
			this.carouselStudyList.shift()

        },
        //跳转
        goUrl(name, item, bigNews = false) {
            if (item) {
                let id = item.id;
                this.$router.push({
                    name: name,
                    params: {
                        type: item.origin ? bigNews ? 'bignews' : 'news' : "study",
                        id: id,
                    },
                });
            } else {
                this.$router.push({
                    name: name,
                });
            }
        },
        //跳转数据平台
        goGw(path) {
            _hmt.push(['_trackEvent', '数据平台', '跳转', '主页'])
            // console.log('window:>> ', window.location);
            window.open(`https://data.zhongsituo.com`);
        },
        //滚动
        scrollTo(num, init) {
            let type = init ? "auto" : "smooth";
            window.scrollTo({
                top: num,
                left: 0,
                behavior: type,
            });
        },
        //按时间排序
        line(arr) {
            arr.sort((a, b) => {
                return b.gmtCreate - a.gmtCreate
            });
        },
        //播放方法
        play(url) {
            this.player.play(url);
        },
        //获取横幅公告
        getBannerText() {
            getBanner({
                origin: 4
            }).then((res)=>{
                this.bannerText = res.data.text
                // console.log('横幅公告',res.data);
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/home.scss";
</style>
